import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { PlayerDecisionsWrapper, SavePlaceHolder } from './Decisions.style';
import { withTheme } from 'styled-components';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import useTracking from '../../utils/hooks/useTracking';
import BuildPlayerMatchup from './utils/BuildPlayerMatchup';

const commonFormat = {
    showHeadShot: false
};

const Decisions = ({
    decisions = {},
    isLoading = false,
    language = 'en',
    deviceInteraction,
    customFormat
}) => {
    const Tracking = useTracking();
    const {
        winner,
        loser,
        save
    } = decisions;

    const PlayerTypes = {
        W: useTranslator('win_abbrev', 'W'),
        L: useTranslator('loss_abbrev', 'L'),
        S: 'S'
    };

    const eraLabel = useTranslator('labelBrief_era', 'ERA');

    const format = useMemo(() => {
        return {
            ...commonFormat,
            ...customFormat
        };
    }, [customFormat]);

    if (isLoading) {
        return <PlayerDecisionsWrapper
            isLoading
        >
            <BuildPlayerMatchup player={{}} format={format} playerType={PlayerTypes.W} isLoading language={language} deviceInteraction={deviceInteraction} eraLabel={eraLabel} PlayerTypes={PlayerTypes} tracking={Tracking} />
            <BuildPlayerMatchup player={{}} format={format} playerType={PlayerTypes.L} isLoading language={language} deviceInteraction={deviceInteraction} eraLabel={eraLabel} PlayerTypes={PlayerTypes} tracking={Tracking} />
            <BuildPlayerMatchup player={{}} format={format} playerType={PlayerTypes.S} isLoading language={language} deviceInteraction={deviceInteraction} eraLabel={eraLabel} PlayerTypes={PlayerTypes} tracking={Tracking} />
        </PlayerDecisionsWrapper>;
    }

    return (
        <PlayerDecisionsWrapper>
            { winner ? <BuildPlayerMatchup player={winner} format={format} playerType={PlayerTypes.W} isLoading={false} language={language} deviceInteraction={deviceInteraction} eraLabel={eraLabel} PlayerTypes={PlayerTypes} tracking={Tracking} /> : null}
            { loser ? <BuildPlayerMatchup player={loser} format={format} playerType={PlayerTypes.L} isLoading={false} language={language} deviceInteraction={deviceInteraction} eraLabel={eraLabel} PlayerTypes={PlayerTypes} tracking={Tracking} /> : null}
            { save ? <BuildPlayerMatchup player={save} format={format} playerType={PlayerTypes.S} isLoading={false} language={language} deviceInteraction={deviceInteraction} eraLabel={eraLabel} PlayerTypes={PlayerTypes} tracking={Tracking} /> : <SavePlaceHolder />}
        </PlayerDecisionsWrapper>
    );
};

Decisions.propTypes = {
    decisions: PropTypes.object,
    isLoading: PropTypes.bool,
    language: PropTypes.string,
    deviceInteraction: PropTypes.object,
    customFormat: PropTypes.object
};

export default withTheme(Decisions);
